"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var play_api_1 = require("@l2p/play-api");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Congrats = function (_a) {
    var onClose = _a.onClose, _b = _a.prize, prize = _b === void 0 ? { type: play_api_1.BonusRewardType.FreeRounds, value: '10', description: '$' } : _b;
    var lang = (0, next_intl_1.useLocale)();
    var t = (0, next_intl_1.useTranslations)('wheel');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? '280px'
            : '360px', height: Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? '380px'
            : '480px', portalNodeId: "modal", onClose: onClose, saveSize: true, showClose: false },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.curveText },
                react_1.default.createElement("span", null, t('congratsRibbonTitle'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.prize },
                react_1.default.createElement("div", null, prize === null || prize === void 0 ? void 0 :
                    prize.value,
                    " ", prize === null || prize === void 0 ? void 0 :
                    prize.description)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text },
                (prize.type === play_api_1.WheelRewardType.Cash ||
                    prize.type === play_api_1.BonusRewardType.Absolute) && (react_1.default.createElement("div", null, t('congratsCashBonus'))),
                prize.type === play_api_1.BonusRewardType.FreeRounds && (react_1.default.createElement("div", null, t('congratsFsBonus'))),
                react_1.default.createElement("div", null, t('congratsActivate'))),
            prize.type === play_api_1.BonusRewardType.Absolute ||
                prize.type === play_api_1.BonusRewardType.FreeRounds ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(link_1.default, { className: "".concat(styles_module_scss_1.default.btn), href: prize.type === play_api_1.BonusRewardType.FreeRounds
                        ? "/".concat(lang, "/account/bonuses/freespins")
                        : "/".concat(lang, "/account/bonuses/cash") },
                    react_1.default.createElement("div", null, t('getBonus'))),
                react_1.default.createElement("div", { onClick: onClose, className: styles_module_scss_1.default.activateLater }, t('activateLater')))) : (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.btn) },
                react_1.default.createElement("div", { onClick: onClose }, t('ok')))))));
};
exports.default = Congrats;
